import TextFill from 'textfilljs';

(function() {
    // init TextFill for programm h1
    TextFill("#h1",{
        maxFontPixels: 160,
        innerTag: 'span',
    });
    /**
     * Resize text in resize window
     */
    window.addEventListener('resize', () => {
        TextFill("#h1",{
            maxFontPixels: 160,
            innerTag: 'span',
        });
    });
})();

